<span class="inverted-answer-badge">
  <span class="type-caption inverted-answer-pill">Inverted</span>
  <button type="button" class="inverted-answer-info" aria-label="What Inverted means"
    [ngbTooltip]="invertedTip" placement="top" container="body" tooltipClass="positive-answer-tooltip"
    triggers="hover focus">
    <svg aria-hidden="true" viewBox="0 0 16 16">
      <circle class="info-bg" cx="8" cy="8" r="8"></circle>
      <circle class="info-glyph" cx="8" cy="4.6" r="1.25"></circle>
      <rect class="info-glyph" x="6.95" y="6.8" width="2.1" height="5.4" rx="1.05"></rect>
    </svg>
  </button>
</span>
<ng-template #invertedTip>
  <div class="positive-answer-tip">
    <span>{{ noName }} is the 100% answer for this question.</span>
    <span>Answering {{ yesName }} opens a gap.</span>
  </div>
</ng-template>
